import { all, call, takeLatest, put } from 'redux-saga/effects'
import {
  rejectPromiseAction,
  resolvePromiseAction
} from 'redux-saga-promise-actions'
import { fetchClassroomTeacherByUserId, editUser } from '../classrooms/services'

import * as actions from './actions'
import * as services from './services'

export function * fetchTeachersRequest ({ payload }) {
  try {
    const response = yield call(services.fetchTeacherss, payload)
    yield put(actions.getTeachersSuccessful(response))
  } catch (error) {
    console.error(error)
    yield put(actions.getTeachersFailure(error))
  }
}

export function * editTeacherRequest ({ payload }) {
  try {
    const response = yield call(editUser, payload)
    yield put(actions.editTeacherSuccessful(response.data))
  } catch (error) {
    console.error(error)
    yield put(actions.editTeacherFailure(error))
  }
}

export function * fetchTeacherByIdRequest ({ payload }) {
  try {
    const response = yield call(services.fetchTeacherById, payload)
    yield put(actions.getTeacherByIdSuccessful(response.data))
  } catch (error) {
    console.error(error)
    yield put(actions.getTeacherByIdFailure(error))
  }
}
export function * removeTeacherSubjectsRequest ({ payload }) {
  try {
    if (payload.ids && payload.ids.length > 0) {
      yield all(
        payload.ids.map(id => {
          return call(services.deleteSubjectTeacher, id)
        })
      )
    }
    yield put(actions.removeTeacherSubjectsSuccessful(payload.ids))
  } catch (error) {
    console.error(error)
    yield put(actions.removeTeacherSubjectsFailure(error))
  }
}

export function * fetchDeletedTeachersRequest ({ payload }) {
  try {
    const response = yield call(services.fetchDeletedTeachers, payload)
    yield put(actions.getDeletedTeachersSuccessful(response))
  } catch (err) {
    console.error(err)
    yield put(actions.getDeletedTeachersFailure(err))
  }
}

export function * removeClassroomTeachersRequest ({ payload }) {
  try {
    if (payload.ids && payload.ids.length > 0) {
      yield all(
        payload.ids.map(id => {
          return call(services.deleteClassroomTeacher, id)
        })
      )
    }
    yield put(actions.removeClassroomTeachersSuccessful(payload.ids))
  } catch (error) {
    console.error(error)
    yield put(actions.removeClassroomTeachersFailure(error))
  }
}

export function * restoreTeacherRequest (action) {
  try {
    const { payload: { schoolTeacherId } } = action
    const response = yield call(services.restoreTeacher, schoolTeacherId)
    resolvePromiseAction(action, response)
  } catch (err) {
    console.error(err)
    rejectPromiseAction(action, err)
  }
}

export function * removeTeacherRequests (action) {
  try {
    const {
      payload: {
        schoolTeacherId,
        userId,
        employedInOtherSchool,
        teacherOccupationId,
        school
      }
    } = action
    yield call(services.deleteSchoolTeacher, schoolTeacherId)
    let classroomTeachersBySchool
    const classroomTeachers = yield call(fetchClassroomTeacherByUserId, userId)
    if (!employedInOtherSchool) {
      yield call(editUser, {
        id: userId,
        data: {
          user_occupations_attributes: [
            {
              id: +teacherOccupationId,
              _destroy: true
            }
          ]
        }
      })
    }
    if (classroomTeachers.data.length > 0) {
      classroomTeachersBySchool = classroomTeachers.data
        .filter(ct => {
          return +ct.classroom.school_id === +school?.school_id
        })
        .map(item => item.id)
      classroomTeachersBySchool.length > 0 &&
        (yield put(
          actions.removeClassroomTeachers({ ids: classroomTeachersBySchool })
        ))
    }
    resolvePromiseAction(action)
  } catch (error) {
    console.error(error)
    rejectPromiseAction(action, error)
  }
}

export function * watchTeachers () {
  yield takeLatest(actions.getTeachers, fetchTeachersRequest)
  yield takeLatest(actions.getTeacherById, fetchTeacherByIdRequest)
  yield takeLatest(
    actions.removeClassroomTeachers,
    removeClassroomTeachersRequest
  )
  yield takeLatest(actions.editTeacher, editTeacherRequest)
  yield takeLatest(actions.removeTeacherSubjects, removeTeacherSubjectsRequest)
  yield takeLatest(actions.getDeletedTeachers, fetchDeletedTeachersRequest)
  yield takeLatest(actions.restoreTeacherRSPA.request, restoreTeacherRequest)
  yield takeLatest(actions.removeTeacherRSPA.request, removeTeacherRequests)
}

export default function * teachersSaga () {
  yield all([watchTeachers()])
}
